import { useI18n } from '#/i18n/hooks/useI18n';
import { ListingViewSection } from '#/modules/listing/components/ListingView/Section/ListingViewSection';
import {
  listingRichTextTruncateAtAbout2Lines,
  ListingRichTextTruncated,
} from '#/modules/listing/components/RichText/Truncated/ListingRichTextTruncated';

type Props = {
  languageProficiency: string | null;
  languageProficiencyTruncated: string | null;
};

export function ListingViewLanguageProficiencySection({
  languageProficiency,
  languageProficiencyTruncated,
}: Props) {
  const { i18n } = useI18n();

  if (!languageProficiency || !languageProficiencyTruncated) return null;

  return (
    <ListingViewSection
      title={
        /* TRANSLATORS: Job Listing Page, section title */
        i18n('Level of Language Proficiency')
      }
    >
      <ListingRichTextTruncated
        showMoreLinkTitle={i18n('Read more about language proficiency')}
        showLessLinkTitle={i18n('Read less about language proficiency')}
        html={languageProficiency}
        truncateAtHeight={
          languageProficiencyTruncated === languageProficiency
            ? null
            : listingRichTextTruncateAtAbout2Lines
        }
      />
    </ListingViewSection>
  );
}
